
function getLocalData(key, parse) {
	if (parse) {
		return JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}::${key}`));
	}
	return localStorage.getItem(`${process.env.STORAGE_USER_KEY}::${key}`);
}

function getLocalStorage() {
	return JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}`));
}

function getLocalToken() {
	return localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
}

function removeLocalData(key) {
	return localStorage.removeItem(`${process.env.STORAGE_USER_KEY}::${key}`);
}

function setLocalData(data, key) {
	if (key) {
		return localStorage.setItem(`${process.env.STORAGE_USER_KEY}::${key}`, data);
	}
	return localStorage.setItem(process.env.STORAGE_USER_KEY, JSON.stringify(data));
}

const methods = {
	getLocalData,
	getLocalStorage,
	getLocalToken,
	removeLocalData,
	setLocalData,
};

export default methods;



// WEBPACK FOOTER //
// ./src/shared/helper.js